export const FETCH_QUIZZES_START = 'FETCH_QUIZZES_START'
export const FETCH_QUIZZES_SUCCESS = 'FETCH_QUIZZES_SUCCESS'
export const FETCH_QUIZZES_ERROR = 'FETCH_QUIZZES_ERROR'
export const CLEAR_QUIZZES = 'CLEAR_QUIZZES'

